var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgQuestionmark = function SvgQuestionmark(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    color: "var(--blue)",
    viewBox: "0 0 24 24"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    stroke: "currentColor",
    d: "M12 .5C18.351.5 23.5 5.649 23.5 12S18.351 23.5 12 23.5.5 18.351.5 12 5.649.5 12 .5Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M10.777 14.84v-2.862q1.49-.072 2.28-.612.81-.56.81-1.639v-.252q0-.828-.515-1.278-.515-.468-1.38-.468-.92 0-1.47.522-.553.522-.755 1.332L8 8.9q.165-.558.478-1.08a3.7 3.7 0 0 1 .828-.919 3.7 3.7 0 0 1 1.177-.648Q11.163 6 12.046 6q.9 0 1.637.252.735.252 1.25.72.515.45.791 1.117.276.648.276 1.44 0 .81-.294 1.459a3.3 3.3 0 0 1-.754 1.08q-.46.45-1.049.738-.588.27-1.213.378v1.657zm.975 4.16q-.7 0-1.03-.324-.313-.342-.313-.864v-.306q0-.523.313-.847.33-.342 1.03-.342.699 0 1.011.342.33.324.331.847v.306q0 .522-.33.864-.314.324-1.012.324"
  })));
};
export default SvgQuestionmark;